export const impressionsId = 1;
export const durationId = 2;
export const exposuresId = 3;
export const smvId = 4;

export const metricOptions = [
    {
        value: 1,
        name: 'Impressions',
        platformTypes: ['1', '2'],
        key: 'impressions',
    },
    {
        value: 2,
        name: 'Duration',
        platformTypes: ['2'],
        key: 'duration',
    },
    {
        value: 3,
        name: 'Exposures',
        platformTypes: ['1', '2'],
        key: 'exposures',
    },
    {
        value: 4,
        name: 'Sponsor Media Value',
        platformTypes: ['1', '2'],
        key: 'sponsorMediaValue',
    },
];
